import { useQuery } from "@tanstack/react-query";
import adminApiClient from "../../api/admin";

export const useNumberOfCollectionsInMarketplace = () => {
  return useQuery<number>({
    queryKey: ["collectionsInMarketplace"],
    queryFn: async () => {
      return adminApiClient.getNumberOfCollectionsInMarketplace();
    },
  });
};
